export const includeTargetTypes = [
    'cofactor',
    'chromatin remodeler',
    'RNA polymerase complex',
    'DNA replication',
    'DNA repair',
    'cohesin',
    'transcription factor',
];
export const excludeTargetTypes = ['recombinant protein'];
